import apiClient from '../connections/api'

const ExecutionReportsService = {
    startExecutionReport: async (reportId) => {
        const response = await apiClient.post('/execution-reports/start', { reportId })
        return response.data
    },

    syncExecutionReports: async (reportIds) => {
        const response = await apiClient.post('/execution-reports/sync', reportIds)
        return response.data
    },

    bulkPrepareExecutionReports: async (reportIds) => {
        const response = await apiClient.post('/execution-reports/bulk-prepare', reportIds)
        return response.data
    },

    bulkAssignExecutionReports: async (reportIds) => {
        const response = await apiClient.post('/execution-reports/bulk-assign', reportIds)
        return response.data
    },

    finishShift: async (executionId, data) => {
        const response = await apiClient.post(`/execution-reports/${executionId}/finish-shift`, data)
        return response.data
    },

    completeExecutionReport: async (executionId, data) => {
        const response = await apiClient.post(`/execution-reports/${executionId}/complete`, data)
        return response.data
    },

    uploadImage: async (formData) => {
        const response = await apiClient.post('/execution-reports/upload-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return response.data
    },

    getExecutionImages: async (executionId) => {
        const response = await apiClient.get(`/execution-reports/${executionId}/execution-images`)
        return response.data
    }
}

export default ExecutionReportsService
